<template>
  <div class="row">
    <div class="col-lg-12">
      <h5 class="text-primary">{{ reportType.title + ' Filtreleme Alanları' }}</h5>
    </div>
    <div class="col-lg-3">
      <v-text-field
          v-model="searchText"
          label="Arama"
          filled
          solo
          dense
          clearable
          append-icon="mdi-magnify"
      >

      </v-text-field>
    </div>
    <div class="col-lg-3">
      <v-menu
          transition="scale-transition"
          offset-y
          :close-on-content-click="false"
          min-width="auto"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-text-field
              :value="formattedDate(dateRangeStart)"
              label="Tarih Aralık Başlangıç"
              prepend-inner-icon="mdi-calendar"
              :error-messages="
                      validationMessages($v.dateRangeStart, 'Tarih Aralık Başlangıç')
                    "
              @input="$v.dateRangeStart.$touch()"
              @blur="$v.dateRangeStart.$touch()"
              readonly
              filled
              solo
              dense
              clearable
              @click:clear="dateRangeStart = null"
              v-bind="attrs"
              v-on="on"
          ></v-text-field>
        </template>
        <v-date-picker
            v-model="dateRangeStart"
            locale="tr"
        ></v-date-picker>
      </v-menu>
    </div>
    <div class="col-lg-3">
      <v-menu
          transition="scale-transition"
          offset-y
          :close-on-content-click="false"
          min-width="auto"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-text-field
              :value="formattedDate(dateRangeEnd)"
              label="Tarih Aralık Bitiş"
              prepend-inner-icon="mdi-calendar"
              :error-messages="
                      validationMessages($v.dateRangeEnd, 'Tarih Aralık Bitiş')
                    "
              @input="$v.dateRangeEnd.$touch()"
              @blur="$v.dateRangeEnd.$touch()"
              readonly
              filled
              solo
              dense
              clearable
              @click:clear="dateRangeEnd = null"
              v-bind="attrs"
              v-on="on"
          ></v-text-field>
        </template>
        <v-date-picker
            v-model="dateRangeEnd"
            locale="tr"
        ></v-date-picker>
      </v-menu>
    </div>
    <div class="col-lg-12 text-end">
      <v-btn small color="primary" @click="filterReport"><v-icon left>mdi-filter</v-icon>FİLTRELE</v-btn>
    </div>
  </div>
</template>

<script>
import {formattedDate} from "@/momentHelper";
import {required} from "vuelidate/lib/validators";
import {validationMessages} from "@/validationMessages";
import {showProcessErrorMessage} from "@/state/alertHelpers";

export default {
  name: "YeniCariRaporu",
  props: {
    reportType: {
      type: Object,
      default: () => {
      }
    }
  },
  computed: {
  },
  data() {
    return {
      dateRangeStart: null,
      dateRangeEnd: null,
      searchText: null,
    }
  },

  validations: {
    dateRangeStart: {
      required,
    },
    dateRangeEnd: {
      required,
    },
  },

  methods: {
    formattedDate,
    validationMessages,
    filterReport() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        this.filterRequestObject = {
          StartDate: this.dateRangeStart,
          EndDate: this.dateRangeEnd,
          SearchText: this.searchText,
        };
        this.$emit("reportFilterChange", this.filterRequestObject);
      } else
        showProcessErrorMessage({
          title: 'Filtreleme Başarısız',
          text: 'Lütfen gerekli alanları doldurun'
        })

    },
  },
  watch: {
    perPage: function (newVal) {
      newVal;
      this.currentPage = 1;
    },

    currentPage: function (newVal) {
      newVal;
    }
  }
}
</script>

<style scoped>

</style>